import type { CurrentAdminRbacPermissionsResponse, RbacRole } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchRbacRoles = async () => {
  const response = await gozokiApiWithAuth.get<RbacRole[]>('/rbac/roles')
  return response.data
}

export const fetchRbacRole = async (roleId: number) => {
  const response = await gozokiApiWithAuth.get<RbacRole>(`/rbac/roles/${roleId}`)
  return response.data
}

export const fetchCurrentAdminRbacPermissions = async () => {
  const response =
    await gozokiApiWithAuth.get<CurrentAdminRbacPermissionsResponse>('/rbac/me/permissions')
  return response.data
}
